import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const healthchecks = defineConnector({
  identifier: "healthchecks",
  name: "Healthchecks",
  tagLine: "Cron job and background task monitoring",
  logo,
  protocol: "http",
  tags: ["observability"],
  defaultUrlPattern: () => "https://healthchecks\\.io/.*",
  auth: (app) => headerAuth([{ name: "X-Api-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Healthchecks, go to **Project Settings** and copy the API key.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://healthchecks.io/api/v3/checks/",
  },
});
